import { Guardian } from '@xaamin/guardian';

Guardian.define('autofacturacion.subir.archivo', (user) => {
  return user.can('autofacturacion.subir.archivo');
});

Guardian.define('autofacturacion.listar.archivos', (user) => {
  return user.can('autofacturacion.listar.archivos');
});

Guardian.define('autofacturacion.listar.tickets', (user) => {
  return user.can('autofacturacion.listar.tickets');
});

Guardian.define('autofacturacion.info.tickets', (user) => {
  return user.can('autofacturacion.info.tickets');
});

Guardian.define('autofacturacion.descargar.excel.procesado', (user) => {
  return user.can('autofacturacion.descargar.excel.procesado');
});

Guardian.define('autofacturacion.descargar.archivo.original', (user) => {
  return user.can('autofacturacion.descargar.archivo.original');
});